export const getDeliverGuyStatus = status => {
  let value = ""
  switch (status) {
    case 1:
      value = "Approved"
      break
    case 2:
      value = "Rejected"
      break
    default:
      value = "Pending"
      break
  }
  return value
}
